import {calculateScore} from "./calculateScore";

export function calculateSuccessStatus( courseStatus, masteryScore, completionStatus ){

    if( courseStatus.scoAmount === 0 ) {
        return "unknown";
    }

    const succeeded = calculateScore( courseStatus ) >= masteryScore;

    if( succeeded ) {
        return "passed";
    }

    if( completionStatus === "completed" ) {
        return "failed";
    }

    return "unknown";
}
